import { getAllCampaignsFromEvents } from 'app/lib/utils/adaya/CampaignUtils';
import Button from 'components/shared/app/Button';
import Constants from 'lib/Constants';
import React, { useEffect, useState } from 'react';
import TrackingService from 'services/tracking/TrackingService';
import { getAccountTimezone, getInnerError, renderLoader } from 'utils/adaya/AdayaUtils';
import { DEFAULT_TIMEZONE, yesterday } from 'utils/DateUtils';
import LocalStorage from 'utils/LocalStorage';
import { clone } from 'utils/ObjectUtils';
import EventItem from './components/EventItem/EventItem';
import UJColumnHeaders from './components/UJColumnHeaders/UJColumnHeaders';
import { UJDrawer } from './components/UJDrawer';
import UJDropdown from './components/UJDropdown/UJDropdown';
import UJTableBody from './components/UJTableBody/UJTableBody';
import './style.scss';

const DEFAULT_DATE_RANGE = [yesterday().startOf('day'), yesterday().endOf('day')];

const UserJourneys = (props) => {
    const [filter, setFilter] = useState({
        channel: 'all',
        campaign: 'all',
        date: DEFAULT_DATE_RANGE
    });
    const [purchaseEvents, setPurchaseEvents] = useState(undefined);
    const [journeyEvents, setJourneyEvents] = useState(undefined);
    const [journeyPurchase, setJourneyPurchase] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [journeyShowHide, setJourneyShowHide] = useState({ session: false, ip: false, client_fingerprint: false });
    const [accountTimezone, setAccountTimezone] = useState(DEFAULT_TIMEZONE);
    const [account, setAccount] = useState();
    const [allCampaigns, setAllCampaigns] = useState([])
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
    const [trackingId, setTrackingId] = useState();
    const [isMobileScroll, setMobileScroll] = useState({ list: false, range: false });
    const [firstLoad, setFirstLoad] = useState(true)
    //const [getAttributed, setGetAttributed] = useState(true);

    // update selected account if user changed
    useEffect(async () => {
        if (props.auth.user) {
            let account = props.auth.user.activeAccount;
            if (account) {
                setAccount(account);
                if (account.tracking?.trackingId) {
                    setTrackingId(account.tracking.trackingId);
                }
            }
        }
    }, [props.auth.user]);

    // // pre-load saved filter settings from localstorage
    // useEffect(() => {
    //     let savedFilter = LocalStorage.get(Constants.USER_JOURNEYS_FILTER);
    //     if (savedFilter) {
    //         // if (savedFilter.date && typeof savedFilter.date == 'string') {
    //         //     savedFilter.date = moment(savedFilter.date);
    //         // }
    //         setFilter({
    //             ...filter,
    //             date: DEFAULT_DATE_RANGE //savedFilter.date
    //         });
    //     } else {
    //         setFilter({
    //             date: DEFAULT_DATE_RANGE
    //         })
    //     }
    // }, []);

    useEffect(() => {
        if (account && trackingId) {
            if (filter.date) {
                if (firstLoad) {
                    setFirstLoad(false)
                }

                onSearch();
            }
        }
    }, [account, trackingId, filter.date, filter.channel, filter.campaign, firstLoad, setFirstLoad])

    const onSearch = async () => {
        try {
            // get all purchase events, to retrieve the order IDs...

            if (!filter.date) return alert("Select a date.");
            if (!account) return setError('Could not locate an account by that tracking ID.');
            if (!trackingId) return setError('Account does not have a tracking ID initialized. Please initialize from the Account page when installing the tracking snippet.');

            setError(undefined);
            setLoading(true);

            //let day = filter.date.clone().startOf('day');
            let start_date = filter.date?.[0]?.startOf('day');
            let end_date = filter.date?.[1]?.endOf('day');
            let timezone = getAccountTimezone(account);
            let timeRange = { start_date: start_date.toISOString(), end_date: end_date.toISOString() };
            setAccountTimezone(timezone);

            // todo: retrieve this from (todo) source dropdown selection
            let includeLastSource = false;

            let params = {
                timeRange,
                includeLastSource,
                onlyPaidsocial: true,
                resolveUnknownObjects: true
            }
            // Use params.useCache = false; to prevent backend caching of purchase event requests.

            if (filter.campaign && filter.campaign !== 'all') {
                params.utm_campaign = filter.campaign.trim();
            }

            if (filter.channel && filter.channel !== 'all') {
                params.utm_source = filter.channel.trim();
            }

            if (filter.source) {
                params.utm_source = filter.source.trim();
            }

            if (filter.medium) {
                params.utm_medium = filter.medium.trim();
            }

            if (filter.ip) {
                params.ip = filter.ip.trim();
            }

            if (filter.client_fingerprint) {
                params.client_fingerprint = filter.client_fingerprint.trim();
            }

            let r = await Promise.all([
                TrackingService.getPurchaseEvents(trackingId, params, false, 'user-journeys'),
            ]);

            let purchaseEvents = r[0];
            setPurchaseEvents(purchaseEvents);

            let campaigns = getAllCampaignsFromEvents(purchaseEvents);
            setAllCampaigns(campaigns);

        } catch (e) {
            console.error('ERROR', e)
            setError(getInnerError(e));
        }

        setLoading(false);
    }

    const onClearFilter = () => {
        setFilter({});
        LocalStorage.set(Constants.USER_JOURNEYS_FILTER, undefined);
    }

    const onTableChange = (pagination, filters, sorter, extra) => {
        setPageSize(pagination.pageSize);
    }

    const loadPurchaseJourney = async (purchase) => {
        try {
            setLoading(true);
            setJourneyEvents(undefined);

            // get all events from same ip, or same client fingerprint
            const r = await TrackingService.getPurchaseJourney(purchase);

            setJourneyPurchase(purchase);

            setTimeout(() => {
                setJourneyEvents(r.events);
                setLoading(false);
            });
        } catch (e) {
            setError(getInnerError(e));
        }
        setLoading(false);
    }

    const showJourney = (r) => {
        loadPurchaseJourney(r);
    }

    const closeJourney = () => {
        setJourneyEvents(undefined);
    }

    const renderPurchase = (pe) => {
        const isPaidsocial = journeyEvents.filter(e => e.utm_medium == 'paidsocial').length >= 1;

        return <div className="event-item purchase flex-col">
            <h6>Journey for Purchase:</h6>

            <div className="item is-paidsocial">
                <div className="label">Paidsocial journey?</div>
                <div className="value">
                    {isPaidsocial &&
                        <div>
                            PAIDSOCIAL
                            {pe.ip &&
                                <div className="">
                                    {`${journeyEvents.filter(e => e.utm_medium == 'paidsocial' && e.ip == pe.ip).length} events match on ip (${pe.ip})`}
                                </div>
                            }
                            {pe.client_fingerprint &&
                                <div className="">
                                    {`${journeyEvents.filter(e => e.utm_medium == 'paidsocial' && e.client_fingerprint == pe.client_fingerprint).length} events match on client_fingerprint (${pe.client_fingerprint})`}
                                </div>
                            }
                            <div className="">
                                {`${journeyEvents.filter(e => e.utm_medium == 'paidsocial' && (e.client_fingerprint == pe.client_fingerprint || e.ip == pe.ip)).length} events match total`}
                            </div>
                        </div>
                    }
                </div>
            </div>

            <div className="item order-id">
                <div className="label">Order ID:</div> <div className="value">{pe.orderId}</div>
            </div>
            <div className="item date">
                <div className="label">Order date:</div> <div className="value">{pe.orderDate}</div>
            </div>
            <div className="item date">
                <div className="label">Event date:</div> <div className="value">{pe.date}</div>
            </div>
            <div className="item price">
                <div className="label">Price:</div> <div className="value">{pe.price}</div>
            </div>
            <div className="item items">
                <div className="label">Items:</div>
                <div className="value flex-col">
                    {pe.items.map(i => <div>{JSON.stringify(i)}</div>)}
                </div>
            </div>
            <div className="item ip">
                <div className="label">IP:</div> <div className="value">{pe.ip}</div>
            </div>
            <div className="item user-agent">
                <div className="label">User Agent:</div> <div className="value">{pe.user_agent}</div>
            </div>
            <div className="item utm-source">
                <div className="label">UTM Source:</div> <div className="value">{pe.utm_source}</div>
            </div>
            <div className="item utm-medium">
                <div className="label">UTM Medium:</div> <div className="value">{pe.utm_medium}</div>
            </div>
            <div className="item utm-campaign">
                <div className="label">UTM Campaign:</div> <div className="value">{pe.utm_campaign}</div>
            </div>
            <div className="item utm-term">
                <div className="label">UTM Term:</div> <div className="value">{pe.utm_term}</div>
            </div>
            <div className="item utm-content">
                <div className="label">UTM Content:</div> <div className="value">{pe.utm_content}</div>
            </div>
            <div className="item client-fingerprint">
                <div className="label">Client Fingerprint:</div> <div className="value">{pe.client_fingerprint}</div>
            </div>
            <div className="item server-fingerprint">
                <div className="label">Server Fingerprint:</div> <div className="value">{pe.server_fingerprint}</div>
            </div>
            <div className="item session">
                <div className="label">Session:</div> <div className="value">{pe.session}</div>
            </div>
            <div className="item parent-session">
                <div className="label">Parent Session:</div> <div className="value">{pe.parent_session}</div>
            </div>
            <div className="item tracking_id">
                <div className="label">Tracking ID:</div> <div className="value">{pe.tracking_id}</div>
            </div>
            <div className="item tracking_id">
                <div className="label">Data:</div> <div className="value">{pe.data}</div>
            </div>
        </div>
    }

    const renderEventJourneyByType = (type, eventData) => {
        return (eventData && eventData.events) ?
            <div className="journey">
                <a href="#" onClick={(e) => { e.preventDefault(); toggleJourney(type) }} className="font-plain-md">Events by {type} ({eventData.events.length})</a>
                <div className={`journey-events ` + (journeyShowHide[type] ? 'show' : 'hide')}>
                    {eventData.events.map(e => {
                        return <EventItem event={e} timezone={accountTimezone} key={e.orderId || e.checkoutToken} />
                    })}
                </div>
            </div>
            :
            <div className="no-events">
                No events found.
                <Button className="btn-close-journey" round color="blue" onClick={() => closeJourney()}>Close Journey</Button>
            </div>
    }

    const renderEventJourney = () => {
        return (journeyEvents && journeyEvents.length) ?
            <div className="journey">
                <a href="#" onClick={(e) => { e.preventDefault(); toggleJourney('journey') }} className="font-plain-md">Events ({journeyEvents.length})</a>
                <div className={`journey-events show`}>
                    {journeyEvents.map((e, i) => {
                        return <EventItem event={e} timezone={accountTimezone} key={`${i}_${e.event}_${e.date}`} />
                    })}
                </div>

            </div>
            :
            <div className="no-events">
                No events found.
                <Button className="btn-close-journey" round color="blue" onClick={() => closeJourney()}>Close Journey</Button>
            </div>
    }

    const toggleJourney = (type) => {
        let jsh = clone(journeyShowHide);
        jsh[type] = !jsh[type];
        setJourneyShowHide(jsh);
    }

    const onCloseDrawer = () => {
        closeJourney()
    }

    return (
        <div className={`user-journeys page-layout ${loading ? "show-loader" : ""} ${!isMobileFilterOpen ? "show-menubar" : ""}`}>

            <div className={`top-menu ${isMobileScroll ? "top-menu-space" : ""}`}>
                <UJDropdown
                    onSearch={onSearch}
                    filter={filter}
                    eventDetail={{ count: purchaseEvents?.length || 0, purchaseAmount: purchaseEvents?.reduce((newAmount, { price = 0 }) => price + newAmount, 0) }}
                    setIsMobileFilterOpen={setIsMobileFilterOpen}
                    isMobileFilterOpen={isMobileFilterOpen}
                    setMobileScroll={setMobileScroll}
                    setFilter={setFilter}
                    allCampaigns={allCampaigns}
                    accountTimezone={accountTimezone}
                />
                <UJColumnHeaders />
            </div>

            <div className="content">

                {!loading && error && <div className="error red pad md center">
                    {error}
                </div>
                }

                {loading && !error && renderLoader()}

                {/* {!loading && journeyEvents &&
                    <div className="journeys">

                        {journeyPurchase &&
                            <div className="original-purchase">
                                {renderPurchase(journeyPurchase)}
                            </div>
                        }

                        <Button className="btn-close-journey" round color="blue" onClick={() => closeJourney()}>Close Journey</Button>

                        <div className="journey-events">
                            { renderEventJourney(journeyEvents) }
                        </div>

                        <div id="journey-by-session">
                            {renderEventJourneyByType('session', journeyEvents.find(e => e.params.session != undefined))}
                        </div>

                        <div id="journey-by-ip">
                            {renderEventJourneyByType('ip', journeyEvents.find(e => e.params.ip != undefined))}
                        </div>

                        <div id="journey-by-client-fingerprint">
                            {renderEventJourneyByType('fingerprint', journeyEvents.find(e => e.params.client_fingerprint != undefined))}
                        </div>
                    </div>
                } */}

                <UJDrawer visible={!!journeyEvents} events={journeyEvents} journeyPurchase={journeyPurchase} onCloseDrawer={onCloseDrawer} />

                {!loading && !journeyEvents && !purchaseEvents &&
                    <div className="start pad lg font-plain-large">
                        Enter a tracking ID and choose a date to start...
                    </div>
                }

                {!loading && !error && purchaseEvents && (

                    !journeyEvents && purchaseEvents.length ?
                        <div className="event-list">
                            <UJTableBody
                                eventsData={purchaseEvents}
                                accountTimezone={accountTimezone}
                                showJourney={showJourney}
                            />
                        </div>
                        :
                        <div className="no-events">
                            <div>{filter?.date?.[1].isSame(new Date(), "day") ? "There aren’t any Purchase Journeys so far today." : "There aren’t any Purchase Journeys for this date range."}</div>
                            <div>Please select a date range to show past purchases.</div>
                        </div>
                )}

            </div>

        </div>

    );

}

export default UserJourneys;